/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Card,
  Divider,
  HStack,
  Heading,
  Link,
  List,
  ListItem,
  Scrollable,
  Stack,
  Text,
} from '@mybridge/ui';
import { useMemo } from 'react';
import {
  MyNetworkContext,
  useMyNetworkContext,
} from 'v4/components/network/context';
import { MyProfileDegreeConnections } from 'v4/components/profile/degree-connections';
import { MyProfileLink } from 'v4/components/profile/profile-link';
import { MyProfileViewsCount } from 'v4/components/profile/views-count';
import { MyProfileVisibility } from 'v4/components/profile/visibility';
import { MyProfileLinksList } from '../links';
import { NetworkBlockUserModal } from './block-user-modal';
import { NetworkBlockAndReportUserModal } from './report-user-modal';

export const MyNetwork = ({ active1, active2, degreeMenuActive, children }) => {
  const networkContext = useMyNetworkContext({});
  const { blockUserDisc, reportUserDisc, allConnectionIDs } =
    networkContext ?? {};
  const menuItems = useMemo(
    () => [
      {
        title: (
          <HStack>
            <Text fontWeight="bold" color="brandPrimary.500">
              {allConnectionIDs?.circle?.length}
            </Text>
            <Text>myCircle</Text>
          </HStack>
        ),
        href: '/profile/network/my-circle',
      },
      // {
      //   title: 'myFollowers',
      //   href: '/profile/network/my-followers',
      // },
      // {
      //   title: 'myFollowing',
      //   href: '/profile/network/my-following',
      // },
    ],
    [allConnectionIDs]
  );
  const menu2Items = useMemo(
    () => [
      // {
      //   title: 'myCircle',
      //   href: '/profile/network/my-circle',
      // },
      ...(allConnectionIDs?.followers?.length
        ? [
            {
              title: (
                <HStack>
                  <Text fontWeight="bold" color="brandPrimary.500">
                    {allConnectionIDs?.followers?.length}
                  </Text>
                  <Text>myFollowers</Text>
                </HStack>
              ),
              href: '/profile/network/my-followers',
            },
          ]
        : []),
      ...(allConnectionIDs?.following?.length
        ? [
            {
              title: (
                <HStack>
                  <Text fontWeight="bold" color="brandPrimary.500">
                    {allConnectionIDs?.following?.length}
                  </Text>
                  <Text>myFollowing</Text>
                </HStack>
              ),
              href: '/profile/network/my-following',
            },
          ]
        : []),
    ],
    [allConnectionIDs]
  );

  return (
    <>
      <MyNetworkContext.Provider value={networkContext}>
        <Stack
          direction={['column', 'row']}
          spacing={4}
          alignItems="flex-start"
        >
          <Box
            w={['100%', '27.5%']}
            pos={['relative', 'sticky']}
            top={['0px', '5rem']}
            maxH="90vh"
            overflowY="hidden"
            _hover={{ overflowY: 'auto' }}
          >
            <Stack>
              <Card p={4} variant="lightBgCard">
                <Heading size="md" color="brandPrimary.500">
                  Network
                </Heading>
                <List as={Stack} mt={4} spacing={0}>
                  {menuItems?.map((mi, miIndex) => (
                    <ListItem
                      bg={active1 === miIndex ? 'brandGray.500' : ''}
                      borderRadius="5"
                      _hover={{ bg: 'brandGray.500' }}
                      p={2}
                      as={Link}
                      href={mi.href}
                      key={miIndex}
                    >
                      {mi.title}
                    </ListItem>
                  ))}
                </List>
              </Card>
              {menu2Items?.length ? (
                <Card p={4} variant="lightBgCard">
                  <List as={Stack} spacing={0}>
                    {menu2Items?.map((mi, miIndex) => (
                      <ListItem
                        bg={active2 === miIndex ? 'brandGray.500' : ''}
                        borderRadius="5"
                        _hover={{ bg: 'brandGray.500' }}
                        p={2}
                        as={Link}
                        href={mi.href}
                        key={miIndex}
                      >
                        {mi.title}
                      </ListItem>
                    ))}
                  </List>
                </Card>
              ) : (
                ''
              )}
              <Card p={4} variant="lightBgCard">
                <MyProfileLinksList />
              </Card>
            </Stack>
          </Box>
          <Stack w={['100%', '70%']} spacing={6}>
            {children}
          </Stack>
          <Scrollable pos="sticky" top="5rem" w={['100%', '27.5%']} maxH="90vh">
            <Stack>
              <Card p={2} variant="lightBgCard">
                <Stack>
                  <MyProfileDegreeConnections active={degreeMenuActive} />
                  <Stack py={2}>
                    <Divider />
                  </Stack>

                  {/* <MyProfilePersonalInfo /> */}
                </Stack>
              </Card>
              <Card p={4} variant="lightBgCard">
                <Stack>
                  <MyProfileVisibility />
                </Stack>
              </Card>
              <Card p={4} variant="lightBgCard">
                <Stack>
                  <MyProfileViewsCount />
                </Stack>
              </Card>
              <Card p={4} variant="lightBgCard">
                <Stack>
                  <MyProfileLink />
                </Stack>
              </Card>
            </Stack>
          </Scrollable>
        </Stack>
        {blockUserDisc?.isOpen ? (
          <NetworkBlockUserModal {...blockUserDisc} />
        ) : (
          ''
        )}
        {reportUserDisc?.isOpen ? (
          <NetworkBlockAndReportUserModal {...reportUserDisc} />
        ) : (
          ''
        )}
      </MyNetworkContext.Provider>
    </>
  );
};
